function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLangGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 137209",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib755mquxa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 117116",
    style: {
      fill: "#00754a"
    },
    d: "M0 0h40.981v41.022H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137201"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137200",
    transform: "translate(7.509 7.51)",
    style: {
      clipPath: "url(#ib755mquxa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121130",
    d: "M40.981 19.33v21.692H20.5a20.511 20.511 0 1 1 20.48-21.8zm-18.8-7.365H11.924v3.418H22.18zm6.835 6.835H11.924v3.42h17.092zm0 6.837H11.924v3.418h17.092z",
    style: {
      fill: "#00754a"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLangGreen);
export default __webpack_public_path__ + "static/media/icon_lang_green.334566280c49cea1cb261592b8a2a025.svg";
export { ForwardRef as ReactComponent };